import { createApp } from 'vue'

import { createRouter, createWebHistory } from 'vue-router'
import PrimeVue from 'primevue/config'
import Aura from '@primevue/themes/aura'
import './assets/global-styles.css'
import './assets/swal-override.css'
import Swal from 'sweetalert2'
import Toast from 'primevue/toast'
import ToastService from 'primevue/toastservice'

import moment from 'moment-timezone'

// Set global timezone
moment.tz.setDefault('Asia/Taipei')
Date.prototype.toJSON = function() {
  return moment(this).tz("Asia/Taipei").format();
};

import App from './App.vue'
import Home from './components/Home.vue'
import About from './components/About.vue'
import Contact from './components/Contact.vue'
import Login from './components/Login.vue'
import Committees from './components/Committees.vue'
import Senators from './components/Senators.vue'
import Representatives from './components/Representatives.vue'
import Agency from './components/Agency.vue'

import News from './components/News.vue'
import ManageAccounts from './components/ManageAccounts.vue'
import SetupAccount from './components/SetupAccount.vue'
import ManageCalendar from './components/ManageCalendar.vue'
import CommitteeMeetings from './components/CommitteeMeetings.vue'
import BillsBySubject from './components/BillsBySubject.vue'
import SubjectForm from './components/SubjectFormRefactored.vue'
import SubjectFormView from './components/SubjectFormView.vue'
import EnactedBills from './components/EnactedBills.vue'
import RedBills from './components/RedBills.vue'
import AdvancingBills from './components/AdvancingBills.vue'
import ChangePassword from './components/ChangePassword.vue'
import Referrals from './components/Referrals.vue'
import ManageLOAssignment from './components/ManageLOAssignment.vue'
import LOTracker from './components/LOTracker.vue'



import WebDev from './components/services/WebDev.vue'
import MobileApps from './components/services/MobileApps.vue'
import UIDesign from './components/services/UIDesign.vue'
import { authStore } from './store/auth.js'
import MultiSelect from 'primevue/multiselect'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import InputNumber from 'primevue/inputnumber'
import Dialog from 'primevue/dialog'
import Select from 'primevue/select'
import IftaLabel from 'primevue/iftalabel';
import Textarea from 'primevue/textarea';
import DatePicker from 'primevue/datepicker';
import SelectButton from 'primevue/selectbutton';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import FloatLabel from 'primevue/floatlabel'
import CascadeSelect from 'primevue/cascadeselect'
import Tooltip from 'primevue/tooltip'
import Chips  from 'primevue/chips'
import InputChips from 'primevue/inputchips'
import Message from 'primevue/message'

const routes = [
  { path: '/login', component: Login, meta: { requiresGuest: true } },
  { path: '/', component: Home, meta: { requiresAuth: true } },
  { path: '/about', component: About, meta: { requiresAuth: true } },
  { path: '/contact', component: Contact, meta: { requiresAuth: true } },
  { path: '/committees', component: Committees, meta: { requiresAuth: true } },
  { path: '/senators', component: Senators, meta: { requiresAuth: true } },
  { path: '/representatives', component: Representatives, meta: { requiresAuth: true } },
  { path: '/agencies', component: Agency, meta: { requiresAuth: true } },

  { path: '/news', component: News, meta: { requiresAuth: true } },
  { path: '/manage-accounts', component: ManageAccounts, meta: { requiresAuth: true } },
  { path: '/setup-account', component: SetupAccount },
  { path: '/manage-calendar', component: ManageCalendar, meta: { requiresAuth: true } },
  { path: '/committee-meetings', component: CommitteeMeetings, meta: { requiresAuth: true } },
  { path: '/bills-by-subject', component: BillsBySubject, meta: { requiresAuth: true } },
  { path: '/subject/new', component: SubjectForm, meta: { requiresAuth: true } },
  { path: '/subject/edit/:id', component: SubjectForm, meta: { requiresAuth: true } },
  { path: '/subject/view/:id', component: SubjectFormView, meta: { requiresAuth: true } },
  { path: '/enacted-bills', component: EnactedBills, meta: { requiresAuth: true } },
  { path: '/services/web', component: WebDev, meta: { requiresAuth: true } },
  { path: '/services/mobile', component: MobileApps, meta: { requiresAuth: true } },
  { path: '/services/design', component: UIDesign, meta: { requiresAuth: true } },
  { path: '/red-bills', component: RedBills, meta: { requiresAuth: true } },
  { path: '/advancing-bills', component: AdvancingBills, meta: { requiresAuth: true } },
  { path: '/change-password', component: ChangePassword, meta: { requiresAuth: true } },
  { path: '/referrals', component: Referrals, meta: { requiresAuth: true } },
  { path: '/lo-tracker', component: LOTracker, meta: { requiresAuth: true } },

  { path: '/manage-lo-assignment', component: ManageLOAssignment, meta: { requiresAuth: true } },


]



authStore.init()

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/login')
  } else if (to.meta.requiresGuest && authStore.isAuthenticated) {
    next('/')
  } else {
    next()
  }
})

const app = createApp(App)
app.use(router)
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      prefix: 'p',
      darkModeSelector: false,
      cssLayer: false
    }
  }
})
app.component('MultiSelect', MultiSelect)
app.component('DataTable', DataTable)
app.component('Column', Column)
app.component('InputText', InputText)
app.component('Button', Button)
app.component('InputNumber', InputNumber)
app.component('Toast', Toast)
app.component('Dialog', Dialog)
app.component('Select', Select)
app.component('IftaLabel', IftaLabel)
app.component('Textarea', Textarea)
app.component('MultiSelet', MultiSelect)
app.component('DatePicker', DatePicker)
app.component('SelectButton', SelectButton)

app.component('IconField', IconField)
app.component('InputIcon', InputIcon)
app.component('FloatLabel', FloatLabel)
app.component('CascadeSelect', CascadeSelect)
app.component('Chips', Chips)
app.component('InputChips', InputChips)
app.component('Message', Message)

app.directive('tooltip', Tooltip)

app.use(ToastService)
app.config.globalProperties.$authStore = authStore


app.mount('#app')